import axios from '@/bootstrap'
const endpoint = 'active-inventory-summary-by-node'

export default class ActiveInventorySummaryByNodeService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }
}
